import React, {useState} from "react";
import PropTypes from "prop-types";
import {Field, reduxForm} from "redux-form";
import Button from "../../../common/Button";
import H from "../../../common/Typography/H";
import P from "../../../common/Typography/P";
import renderTextField from "./render-text-field";
import renderPhoneField from "./render-phone-field";
import renderFileInput from "./render-file-input";

import styles from "./service-form.module.scss";

const validate = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = `Обязательное поле`;
  }
  if (!values.phone && !values.email) {
    errors.phone = `Укажите, пожалуйста, контактный телефон и/или адрес эл. почты`;
    errors.email = `Укажите, пожалуйста, контактный телефон и/или адрес эл. почты`;
  }
  return errors;
};

function ServiceForm({
  handleSubmit,
  onRequestClose,
  submitFailed,
  submitSucceeded,
  submitting,
  valid
}) {
  const [submitAgain, setSubmitAgain] = useState(false);
  if (!submitSucceeded || !valid || submitAgain) {
    return (
      <form
        className={styles.root}
        encType="multipart/form-data"
        onSubmit={(event) => {
          event.preventDefault();

          handleSubmit();
          setSubmitAgain(false);
        }}
      >
        <H level={3} className={styles.title}>
          Обратная связь
        </H>
        <div className={styles.row}>
          <Field name="name" component={renderTextField} label="Ваше имя" />
        </div>
        <div className={styles.row}>
          <Field name="phone" component={renderPhoneField} label="Телефон" />
        </div>
        <div className={styles.row}>
          <Field name="email" component={renderTextField} label="Эл. почта" />
        </div>
        <div className={styles.row}>
          <Field
            name="notes"
            component={renderTextField}
            label="Подробности заказа"
            multiline={true}
            rows={2}
          />
        </div>
        <div className={styles.fileUpload}>
          <Field
            name="link"
            component={renderTextField}
            label="Ссылка на файл"
          />
          <span className={styles.separator}>или</span>
          <Field
            name="file"
            component={renderFileInput}
            className={styles.fileButton}
          />
        </div>
        <div className={styles.footer}>
          <Button
            type="submit"
            disabled={!valid || submitting}
            variant="contained"
            style="primary"
            size="large"
          >
            Отправить
          </Button>
          <div className={styles.disclaimer}>
            Нажимая «Отправить», вы соглашаетесь с правилами пользования и
            политикой конфиденциальности
          </div>
        </div>
      </form>
    );
  } else if (submitSucceeded) {
    return (
      <div className={styles.root}>
        <H level={3} className={styles.title}>
          Отправлено
        </H>
        <P>Спасибо! Мы свяжемся с вами в течение дня</P>
        <div className={styles.footer}>
          <Button
            variant="contained"
            style="secondary"
            component="span"
            onClick={onRequestClose}
          >
            Закрыть
          </Button>
        </div>
      </div>
    );
  } else if (submitFailed) {
    return (
      <div className={styles.root}>
        <H level={3} className={styles.title}>
          Произошла ошибка
        </H>
        <P>Мы не получили ваши данные, обратитесь к онлайн-консультанту</P>
        <div className={styles.footer}>
          <Button
            variant="contained"
            style="secondary"
            component="span"
            onClick={() => {
              setSubmitAgain(true);
            }}
          >
            Попробовать еще раз
          </Button>
        </div>
      </div>
    );
  }
}

ServiceForm.propTypes = {
  handleSubmit: PropTypes.func,
  onRequestClose: PropTypes.func,
  submitFailed: PropTypes.bool,
  submitSucceeded: PropTypes.bool,
  submitting: PropTypes.bool,
  valid: PropTypes.bool
};

export default reduxForm({
  form: `serviceForm`,
  destroyOnUnmount: false,
  validate
})(ServiceForm);
